export const pharmacyProcedureCreateTranslations = {
    en: {
        fetchOpdFailed: "Failed to fetch OPD numbers!",
        addMedicineStockWarning: "First add medicines to camp stock",
        submitSuccess: "Prescription added successfully!",
        submitFailed: "Failed to add prescription!",
        submitting: "Submitting...",
        submitPrescription: "Submit Prescription",

        patientInformation: "Patient Information",
        tokenNo: "Token No",
        tokenPlaceholder: "Search Token No eg. 00005",
        beneficiaryName: "Beneficiary Name",
        date: "Date",

        medicines: "Medicines",
        addMedicine: "Add Medicine",
        checkMedicineEntries: "Please check medicine entries",
        medicineName: "Medicine Name",
        quantity: "Quantity",
        quantityPlaceholder: "Enter qty",
        available: "Avl",
        remark: "Remark",
        remarkPlaceholder: "Optional",
        dosage: "Dosage",

        remarks: "Remarks"
    },
    mr: {
        fetchOpdFailed: "ओपीडी क्रमांक आणण्यात अयशस्वी!",
        addMedicineStockWarning: "प्रथम शिबिर स्टॉकमध्ये औषधे जोडा",
        submitSuccess: "प्रिस्क्रिप्शन यशस्वीरित्या जोडले!",
        submitFailed: "प्रिस्क्रिप्शन जोडण्यात अयशस्वी!",
        submitting: "सबमिट करत आहे...",
        submitPrescription: "प्रिस्क्रिप्शन सबमिट करा",

        patientInformation: "रुग्ण माहिती",
        tokenNo: "टोकन क्रमांक",
        tokenPlaceholder: "टोकन क्रमांक शोधा उदा. 00005",
        beneficiaryName: "लाभार्थीचे नाव",
        date: "तारीख",

        medicines: "औषधे",
        addMedicine: "औषध जोडा",
        checkMedicineEntries: "कृपया औषध नोंदी तपासा",
        medicineName: "औषधाचे नाव",
        quantity: "प्रमाण",
        quantityPlaceholder: "प्रमाण प्रविष्ट करा",
        available: "उपलब्ध",
        remark: "टिप्पणी",
        remarkPlaceholder: "पर्यायी",
        dosage: "डोस",

        remarks: "शेरा"
    }
};
